import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { LANGUAGE } from '@/enums';
import axios from 'axios';
import backend from 'i18next-http-backend';
import _get from 'lodash/get';
import cn from './cn/translation.json';
import en from './en/translation.json';
import { convertLanguageJsonToObject } from './translations';
import { AuthService } from '@/services';

export const translationsJson = {
  [LANGUAGE.EN]: { translation: en },
  [LANGUAGE.CN]: { translation: cn },
};

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en);

const getTranslation = async (path: string, language: string) => {
  try {
    return axios.get(path + '/' + language + '.json');
  } catch (_e) {}
};

const addDefaultTranslation = () => {
  i18next.addResourceBundle(
    LANGUAGE.EN,
    'translation',
    translationsJson[LANGUAGE.EN].translation,
    true,
    true,
  );
  i18next.addResourceBundle(
    LANGUAGE.CN,
    'translation',
    translationsJson[LANGUAGE.CN].translation,
    true,
    true,
  );
};

let getSubdomain: any = null;

let fetchingSubdomain: any = null;

export const i18n = i18next
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .use(backend)
  .init({
    backend: {
      request: async (options: any, url: any, payload: any, callback: any) => {
        const language = localStorage.getItem('i18nextLng') || LANGUAGE.EN;

        try {
          fetchingSubdomain = fetchingSubdomain
            ? fetchingSubdomain
            : AuthService.getSubdomain();

          const getSubdomainResponse = await fetchingSubdomain;
          fetchingSubdomain = null;

          const tenant: any = _get(getSubdomainResponse, 'data', '');

          const { subdomain } = tenant;

          if (subdomain === 'amili') {
            addDefaultTranslation();
            if (language.includes('-')) {
              i18next.changeLanguage(LANGUAGE.EN);
            }
            callback(null, { status: 200 });
            return;
          }
          const resource = i18next.getResourceBundle(language, 'translation');
          if (resource) {
            callback(null, { status: 200 });
            return;
          }
          if (language.includes('-')) {
            i18next.changeLanguage(LANGUAGE.EN);
            addDefaultTranslation();
            callback(null, { status: 200 });
            return;
          }

          const dbConfig = _get(getSubdomain, 'data', [])?.dbConfig
            ?.organization;
          const pathLabel = dbConfig?.pathLabel;
          if (!dbConfig || !pathLabel) {
            addDefaultTranslation();
            callback(null, { status: 200 });
            return;
          }
          const translation = await getTranslation(pathLabel, language);
          if (translation) {
            const { data = {} } = translation;
            i18next.addResourceBundle(
              language,
              'translation',
              data,
              true,
              true,
            );
            callback(null, { status: 200 });
          } else {
            addDefaultTranslation();
            callback(null, { status: 200 });
          }
        } catch (_e) {
          addDefaultTranslation();
          callback(null, { status: 200 });
        }
      },
    },
    // resources: translationsJson,
    fallbackLng: LANGUAGE.EN,
    debug: false,
    // process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export { i18next as i18nInit };
